var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
    _c("div", { staticClass: "dropdown" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-sm dropdown-toggle clickable",
          staticStyle: { transition: "all 0.4s ease" },
          attrs: { "data-toggle": "dropdown" },
        },
        [_vm._v("\n      " + _vm._s(_vm.currentText) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dropdown-menu" },
        [
          _vm._l(_vm.options, function (item, index) {
            return _vm._t(
              "items",
              function () {
                return [
                  _c(
                    "a",
                    {
                      key: index,
                      staticClass: "dropdown-item clickable",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.select(item)
                        },
                      },
                    },
                    [
                      _vm.isSelected(item)
                        ? _c("i", { staticClass: "material-icons" }, [
                            _vm._v("done"),
                          ])
                        : _vm._e(),
                      _vm._v("\n          " + _vm._s(item.name) + "\n        "),
                    ]
                  ),
                ]
              },
              { item: item }
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm.isCustomSelected
      ? _c(
          "div",
          {
            staticClass: "form-group-material w-10 ml-2 mb-0",
            staticStyle: { width: "6rem !important" },
          },
          [
            _c("input", {
              staticClass:
                "material-input form-control form form-control-filled",
              attrs: {
                name: "customDaysPicker",
                type: "number",
                value: "0",
                min: "1",
                pattern: "[1-9][0-9]*",
              },
              on: { input: _vm.handleCustomDaysPicker },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("label", { staticClass: "title text-light-gray mb-2 mb-lg-0" }, [
              _vm._v(_vm._s(_vm.$tc("global.words.day", 2))),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }